// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'dataviz-line-multi';

export const Component = () => (
  <path d='M0 0h1v21h21v1H0V0Zm10.75 12.5a1.75 1.75 0 0 1 1.724 2.053l3 1.5a1.75 1.75 0 1 1-.448.894l-3-1.5a1.747 1.747 0 0 1-2.552 0l-3 1.5a1.75 1.75 0 1 1-.448-.894l3-1.5A1.75 1.75 0 0 1 10.75 12.5Zm6 4a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm-12 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm6-3a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm6-10.5a1.75 1.75 0 1 1-1.356 2.856l-2.904 1.21a1.75 1.75 0 0 1-2.782 1.59l-3.316 2.488a1.75 1.75 0 1 1-.6-.8l3.316-2.488a1.75 1.75 0 0 1 2.997-1.713l2.905-1.209A1.75 1.75 0 0 1 16.75 3Zm-12 8a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm6-4.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm6-2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Z' />
);

export const viewBox = '0 0 22 22';
